<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8184 5.43284C11.7731 5.43284 5.2512 11.9548 5.2512 20C5.2512 28.0452 11.7731 34.5672 19.8184 34.5672C27.8636 34.5672 34.3855 28.0452 34.3855 20C34.3855 11.9548 27.8636 5.43284 19.8184 5.43284ZM3.81836 20C3.81836 11.1634 10.9818 4 19.8184 4C28.6549 4 35.8184 11.1634 35.8184 20C35.8184 28.8366 28.6549 36 19.8184 36C10.9818 36 3.81836 28.8366 3.81836 20Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8184 9.73134C20.214 9.73134 20.5348 10.0521 20.5348 10.4478V20C20.5348 20.3957 20.214 20.7164 19.8184 20.7164C19.4227 20.7164 19.1019 20.3957 19.1019 20V10.4478C19.1019 10.0521 19.4227 9.73134 19.8184 9.73134Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.087 20C30.087 20.3957 29.7663 20.7164 29.3706 20.7164H19.8184C19.4227 20.7164 19.1019 20.3957 19.1019 20C19.1019 19.6043 19.4227 19.2836 19.8184 19.2836H29.3706C29.7663 19.2836 30.087 19.6043 30.087 20Z"
      class="fill-current"
    />
  </svg>
</template>
